import { useHydratedExperimentVariant } from 'src/utils/hydrated-experiment'
import { Experiments } from '../constants'

type Variant = 'control' | 'treatment'

export function useArtworkTacksPaginationExperiment() {
  const { value: variant, enableExposure } =
    useHydratedExperimentVariant<Variant>(
      Experiments.ArtworkTacksPagination,
      'control',
      { autoExpose: false },
    )

  return {
    isPaginated: variant === 'treatment',
    enableExposure,
  }
}
